declare const __STOREFRONT_ANALYTICS_VERSION__: string;

export const STOREFRONT_ANALYTICS_VERSION: string =
  typeof __STOREFRONT_ANALYTICS_VERSION__ !== "undefined"
    ? __STOREFRONT_ANALYTICS_VERSION__
    : "0.0.0";
